import axios from 'axios';
import router from '@/router'
import store from '@/store'

const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_HEADER_NAME = 'X-CSRFToken';

const session = axios.create({
  // baseURL: 'http://localhost:8000',
  baseURL: 'https://nastrojeb.sancananavrat.sk/',
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
});

session.interceptors.response.use(function (response) {
  return response
}, function (error) {
  // Handle network errors or errors without response
  if (!error.response) {
    store.commit('notifications/raiseError', { 
      "chyba": "Chyba spojenia so serverom. Skontrolujte pripojenie k internetu." 
    });
    return Promise.reject(error);
  }

  // Handle server errors (500)
  if (error.response.status === 500) {
    store.commit('notifications/raiseError', { "chyba": "chyba" });
    return Promise.reject(error);
  }

  // Handle other errors with response data
  store.commit('notifications/raiseError', error.response.data);

  // Handle unauthorized (401)
  if (error.response.status === 401) {
    store.dispatch('auth/logout').then(() => router.push('/login'));
  }

  return Promise.reject(error);
})

export default session;